import React from 'react'

const Slide = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M10 5L16.5 12.5833L10 20.1667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
</svg>
    )
}

export default Slide
